angular.module('elfium').constant('TASK_FIELD_TYPES', {
	BOOLEAN: ['priorita'],
	DATE: ['termin']
}).constant('TASK_TYPES', {
	KOTEVRENI: '0-K Otevření',
	POTREBA: '1-Potřeba',
	NABIDKA: '2-Nabídka', 
	KUZAVRENI: '3-K Uzavření'
}).constant('TASK_STATES', {
	NAPLANOVANO: 'Naplánováno',
	SPLNENO: 'Splněno',
	NESPLNENO: 'Nesplněno'
}).constant('TASK_REQUIRED_FIELDS', {
	typ: 'typ',
	popis: 'popis',
	kontaktId: 'osoba',
	userId: 'konzultant',
	obchodniPripadId: 'obchodní případ',
	termin: 'termín'
});


// WEBPACK FOOTER //
// ./src/app/components/task/taskConstants.ts